// Pure logic for the Failed_Payment_Flag (membership-payment-recovery,
// Requirement 3.2/3.3): flag when the latest payment attempt for an entity
// failed. A later COMPLETED record clears the flag; a later FAILED record sets
// it again. Tied timestamps prefer COMPLETED to avoid a false alarm.

export interface PaymentRecordLike {
  entityId: string;
  status: string;
  timestamp: string;
}

export function computeFailedPaymentEntityIds(records: PaymentRecordLike[]): Set<string> {
  const latest = new Map<string, { time: number; failed: boolean; completed: boolean }>();

  for (const record of records) {
    if (!record.entityId || !['FAILED', 'COMPLETED'].includes(record.status)) continue;
    const parsed = new Date(record.timestamp).getTime();
    const time = Number.isFinite(parsed) ? parsed : Number.NEGATIVE_INFINITY;
    const current = latest.get(record.entityId);

    if (!current || time > current.time) {
      latest.set(record.entityId, {
        time,
        failed: record.status === 'FAILED',
        completed: record.status === 'COMPLETED',
      });
    } else if (time === current.time) {
      if (record.status === 'FAILED') current.failed = true;
      if (record.status === 'COMPLETED') current.completed = true;
    }
  }

  const flagged = new Set<string>();
  for (const [entityId, state] of latest) {
    if (state.failed && !state.completed) flagged.add(entityId);
  }
  return flagged;
}
